import { render, staticRenderFns } from "./SourceAuthorities.vue?vue&type=template&id=6b34e124&scoped=true&"
import script from "./SourceAuthorities.vue?vue&type=script&lang=js&"
export * from "./SourceAuthorities.vue?vue&type=script&lang=js&"
import style0 from "./SourceAuthorities.vue?vue&type=style&index=0&id=6b34e124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b34e124",
  null
  
)

export default component.exports